export const MAIN_DOCUMENTATION_CONFLUENCE_PAGE_ID = 606798746;
